import axios from '../localAxios';

type LongMessage = {
  id: number;
  message: {
    data: {
      activityInstance: number;
      hidden: boolean;
      id: number;
      isCorrect: boolean;
      question: number;
      selectionAnswers: [];
      studentName: string;
      team: number;
      textAnswers: Array<{ answer_text: string }>;
      userUuid: string;
    };
  };
};

const getLongMessage = async (
  longMessageId: number,
  activityInstanceId: number
) => {
  return axios.get<LongMessage>(
    `${window.APP_CONFIG.TEACHER_SERVICE}/activities/${activityInstanceId}/long-message/${longMessageId}`
  );
};

export { getLongMessage };
